import React, { useEffect } from 'react';
import { Form, Formik } from 'formik';

import IconInput from '../../components/Inputs/IconInput';
import Button from '../../components/Button';
import {
  SearchTalentSchema,
  initialSearchValue,
} from '../../schema/score.schema';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useVerifySoftSkillEmailMutation } from '../../reactWrapper/Redux/apiSlice';
import { toast } from 'react-toastify';
import PageIntro from '../../components/PageIntro/PageIntro';

let history
const SearchTalent = () => {
   const[verifySoftSkillEmail, {isSuccess, data, error}] = useVerifySoftSkillEmailMutation({ fixedCacheKey: 'shared-update-post'})
   history = useHistory();
   console.log('verify', data)

   const handleSubmit = (values, {resetForm}) => {

   const email = new FormData()
         email.append('email', values.email)
         verifySoftSkillEmail(email)
         resetForm()

  }

  useEffect(()=>{
    if(isSuccess){
      history.push('/search-talent/result');
      }
      else if(error){
      toast.error(error.data.message)
      }
  })
 

  return (
    <div className='mx-auto max-w-3xl space-y-6'>
      <PageIntro
        title='Talent HR Rating'
        description='Find a talent by email to enter their HR result.'
      />

      <div className='rounded-2xl border bg-card p-6 shadow-ui-sm'>
        <Formik
          onSubmit={handleSubmit}
          validationSchema={SearchTalentSchema}
          enableReinitialize
          initialValues={initialSearchValue}
        >
          {({
            values,
            setFieldTouched,
            isValid,
            setFieldValue,
            errors,
            handleSubmit,
            ...formik
          }) => (
            <Form className='flex flex-col gap-4'>
              <IconInput
                placeholder={'search talent with email'}
                name='email'
                id='email'
                type='email'
                value={values?.email}
                isValid={values?.email && !errors?.email}
                setFieldTouched={setFieldTouched}
                handleSubmit={handleSubmit}
              />
              <div className='mt-2 flex items-center justify-end border-t pt-4'>
                <Button
                  className='bg-brand-orange hover:bg-brand-orange-600'
                  type='submit'
                >
                  Search
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default SearchTalent;
